import * as React from "react";
import { CardWrap, CardWrapWithMobile, StarHolder, StarIconfontHolder } from "./styles";
export const CommentStarForWeb = (props) => {
    return (React.createElement(CardWrap, { key: "commentStar" },
        React.createElement(React.Fragment, null, RenderStart(props)),
        props.children));
};
export const CommentStarForM = (props) => {
    return (React.createElement(CardWrapWithMobile, { key: "commentStar" },
        React.createElement(React.Fragment, null, RenderStart(props)),
        props.children));
};
function RenderStart(props) {
    var _a;
    if ((_a = props.settingOption) === null || _a === void 0 ? void 0 : _a.icon) {
        return RenderStartWithIconfont(props);
    }
    return RenderStartWithBg(props);
}
function RenderStartWithIconfont(props) {
    const { rateScore, settingOption = {} } = props;
    return [1, 2, 3, 4, 5].map((i, idx) => {
        if (rateScore >= i) {
            return React.createElement(StarIconfontHolder, Object.assign({ key: idx }, settingOption, { className: "iconfont icon-ic_star" }));
        }
        if (Math.ceil(rateScore) === i) {
            const percentWidth = (rateScore - i + 1).toFixed(2);
            return (React.createElement(StarIconfontHolder, Object.assign({ key: idx }, settingOption, { className: "iconfont icon-ic_star_unselect" }),
                React.createElement("span", { className: "iconfont icon-ic_star", style: { width: `${+percentWidth * 100}%` } })));
        }
        return (React.createElement(StarIconfontHolder, Object.assign({ key: idx }, settingOption, { className: "iconfont icon-ic_star_unselect" })));
    });
}
function RenderStartWithBg(props) {
    const { rateScore } = props;
    return [1, 2, 3, 4, 5].map((i, idx) => {
        const attr = getStarDomAttr();
        if (rateScore >= i) {
            return React.createElement(StarHolder, Object.assign({ key: idx }, attr.active));
        }
        if (rateScore < i && Math.ceil(rateScore) === i) {
            return (React.createElement(StarHolder, Object.assign({ key: idx }, attr.normal),
                React.createElement("span", { style: {
                        width: `${(rateScore - i + 1) * 100}%`,
                    } })));
        }
        return React.createElement("i", { key: idx });
    });
}
function getStarDomAttr() {
    return {
        active: {
            "data-active": true,
        },
        normal: {},
    };
}
